const base = {
    API_ORGANIZATOIN: 'Pearson',
    PRODUCT_MODEL_REGION: 'Everest',
    API_KEY: 'WDXJHOqFDPzIj8LLf5LQFNqUJQzUo8uv',
    ENVIRONMENT: 'prod',
    CLIENT_ID: 'sWzPLSMPFeOaO4N5TJ08j3L4oCnQd41I',
    FUSION_CHART_KEY: '2mA4mpE-11E2B4G1A2C2C5B3D2F2E3C4B3I4zegB5B2D3oE3E1G2bapC2A3E2B-7ziB3D5D1rjvG4A9A32A6C8B3B5D2G4F4D3iacA5C5JE3uwfC5A2B2E-13nG2AC2F1zduC7E2B4G2H2I2A2D8E2D2E6F1G1H3m==',
    ALS_MARK_BOOK: 'app/reports/markbook/list'
};

export default base;